import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propOneOfType, propShape, } from '../../../helpers/custom-prop-types';
import TagIcon from '../../Icon/Svg/TagIcon';
import SlideSearchTopCategoryItem from './SlideSearchTopCategoryItem';
const SlideSearchTopCategory = (props) => {
    const { aggs, categories } = props;
    return (_jsxs("section", Object.assign({ className: 'section image_search' }, { children: [_jsxs("h2", Object.assign({ className: 'category_list_title' }, { children: [_jsx(TagIcon, {}), "\u30AB\u30C6\u30B4\u30EA\u30FC\u304B\u3089\u63A2\u3059", _jsx("span", Object.assign({ className: 'category_list_title_beta_icon' }, { children: "\u03B2\u7248" }))] })), _jsx("div", Object.assign({ className: 'category_search_box' }, { children: _jsx("ul", Object.assign({ className: 'category_list' }, { children: categories.map((v) => (_jsx(SlideSearchTopCategoryItem, { category: v, isDisabled: !aggs[v.id] }, v.id))) })) }))] })));
};
SlideSearchTopCategory.propTypes = {
    aggs: propOneOfType([propShape(), propArrayShape()]),
    categories: propArrayShape().isRequired,
};
SlideSearchTopCategory.defaultProps = {
    aggs: {},
};
export default SlideSearchTopCategory;
